import React from 'react';
import { Box, Typography, Breadcrumbs, Link, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon, NavigateNext as NavigateNextIcon, Edit as EditIcon } from '@mui/icons-material';
import CollectionActionButtons from '../../../../components/common/CollectionActionButtons';

const Header = ({ title, onBack, collectionId, status, onActionComplete, onEditClick }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />} 
        aria-label="breadcrumb"
        sx={{ mb: 2 }}
      >
        <Link 
          color="inherit" 
          onClick={onBack}
          sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', '&:hover': { textDecoration: 'underline' } }}
        >
          <ArrowBackIcon fontSize="small" sx={{ mr: 0.5 }} />
          Collections
        </Link>
        <Typography color="text.primary" sx={{ 
          maxWidth: '300px', 
          whiteSpace: 'nowrap', 
          overflow: 'hidden', 
          textOverflow: 'ellipsis' 
        }}>
          {title}
        </Typography>
      </Breadcrumbs>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h4" component="h1" fontWeight="700">
            {title}
          </Typography>
          {status === 'DRAFT' && onEditClick && (
            <IconButton onClick={onEditClick} color="primary" sx={{ ml: 1 }} aria-label="edit collection details">
              <EditIcon />
            </IconButton>
          )}
        </Box>
        {collectionId && (
          <CollectionActionButtons
            collectionId={collectionId}
            status={status}
            onActionComplete={onActionComplete}
            showText={true}
            size="medium"
          />
        )}
      </Box>
    </Box>
  );
};

export default Header;
